import React, { useEffect } from "react";
import "./DementiaCare.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import dementiaImg from "../../Asset/Images/DimentiaCare.png";

const DementiaCare = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  // Keys for the 8 dementia support cards
  const dementiaPoints = [
    "dementia.point1",
    "dementia.point2",
    "dementia.point3",
    "dementia.point4",
    "dementia.point5",
    "dementia.point6",
    "dementia.point7",
    "dementia.point8"
  ];

  return (
    <div className="dim_page">
      {/* HERO SECTION */}
      <section className="dim_hero">
        <div className="dim_card_container">
          <div className="dim_content" data-aos="fade-right">
            <span className="dim_service_tag">{t('dementia.service_tag')}</span>
            <h1>
              {t('dementia.title_start')} <span>{t('dementia.title_end')}</span>
            </h1>
            <p>{t('dementia.hero_desc')}</p>
          </div>

          <div className="dim_image" data-aos="fade-left">
            <img src={dementiaImg} alt={t('dementia.title_start') + " " + t('dementia.title_end')} />
          </div>
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="dim_details">
        <h2 data-aos="fade-up">{t('dementia.details_title')}</h2>
        <div className="dim_grid">
          {dementiaPoints.map((key, index) => (
            <div className="dim_card" key={index} data-aos="zoom-in">
              {t(key)}
            </div>
          ))}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="dim_cta" data-aos="fade-up">
        <h2>{t('dementia.cta_title')}</h2>
        <p>{t('dementia.cta_desc')}</p>
        <NavLink to="/Contactus">
          <button className="assisted_cta_btn">
            {t('common.contact_us')}
          </button>
        </NavLink>
      </section>
    </div>
  );
};

export default DementiaCare;